import ICompany from "@/module/main/dto/financing-v3/ICompany";
import IContact from "./IContact";
import IPerson from "./IPerson";
import IAddressFlags from "@/module/main/dto/customer/IAddressFlags";

export default class Company implements ICompany
{
    public readonly businessIdentificationNumber?: string;
    public readonly contacts?: IContact[];
    public readonly addresses?: IAddressFlags[];
    public readonly representatives?: IPerson[];

    constructor(props: ICompany)
    {
        this.businessIdentificationNumber = props.businessIdentificationNumber;
        this.contacts = props.contacts;
        this.addresses = props.addresses;
        this.representatives = props.representatives;
    }
}
